import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NzSegmentedOption, NzSegmentedOptions } from 'ng-zorro-antd/segmented';

@Component({
  selector: 'liberro-segmented-switch',
  standalone: false,
  templateUrl: './liberro-segmented-switch.component.html',
  styleUrl: './liberro-segmented-switch.component.less'
})
export class LiberroSegmentedSwitchComponent {
  @Input() public options: string[] | NzSegmentedOptions = [];
  @Input({ required: true }) public value!: string | number | NzSegmentedOption;
  // todo - why is there duplicit config/options input for value instead of using it directly
  @Input() public enhancedOptions: { label: string; value: string | number; disabled?: boolean }[] = [];
  @Input() public size: 'default' | 'large' = 'default';
  @Input() public selectedBold = false;
  @Input() public transparentStyles = false;
  @Output() private valueChanged = new EventEmitter<string | number>();

  public handleValueChange(changedValue: string | number): void {
    this.valueChanged.emit(changedValue);
  }

}
